const fetchConfig = (url, mockUrl, config) => {
  if (process.env.REACT_APP_DEVELOPMENT_MODE === "enabled") {
    return [mockUrl];
  } else {
    return [url, config];
  }
};

export default fetchConfig;
